module.exports = __webpack_public_path__ + "img/5质量提升项目建设.8e07d5eb.png";